import { useEffect, useRef } from "react";

export default function TurnstileWidget({
  siteKey,
  action = undefined,         // "login", "recover", "autologin", etc.
  onToken,                    // (token|null) => void
  theme = "light",
  size = "normal",
}) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    // Si el script no cargó todavía, no hacemos nada.
    if (!window.turnstile || !containerRef.current) return;

    // Render del widget SOLO una vez
    widgetIdRef.current = window.turnstile.render(containerRef.current, {
      sitekey: siteKey,
      action,
      theme,
      size,
      callback: (t) => onToken?.(t),
      "expired-callback": () => onToken?.(null),
      "error-callback": () => onToken?.(null),
    });

    // Cleanup: evita iframes “zombies” (especialmente en iOS)
    return () => {
      try {
        if (window.turnstile && widgetIdRef.current) {
          window.turnstile.remove(widgetIdRef.current);
        }
      } catch (e) {
        // no-op
      } finally {
        widgetIdRef.current = null;
      }
    };
  }, [siteKey, action]); // si se cambia action, se remonta limpio

  return (
    <div
      ref={containerRef}
      style={{
        minHeight: 80,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    />
  );
}
